import { render, staticRenderFns } from "./licenses_ios.vue?vue&type=template&id=fc6014fe&scoped=true"
import script from "./licenses_ios.vue?vue&type=script&lang=js"
export * from "./licenses_ios.vue?vue&type=script&lang=js"
import style0 from "./licenses_ios.vue?vue&type=style&index=0&id=fc6014fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6014fe",
  null
  
)

export default component.exports